export default __webpack_public_path__ + "locales/ko-KR/DeleteThirdPartyDialog.json?hash=1ae0d71fa2037a2af8b44f4b206da98f";